<template>
  
  <div v-redirect-if-no-permission:RESTRICTED_AREA>
    <loading-component :value="loading"/>
    <DataTable ref="dataTable" url="restricted-area" :fieldsHiddenMain="['deleted_at']" perPage="100" :titles="titles"
      :actionsExtraMain="actionsExtraMain" :formatter="formatter" :title="$t('locationsPage.restrictedAreasTitle')" />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import axios from "axios";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "RestrictedAreas",
  title() {
    return this.$t("locationsPage.restrictedAreasTitle");
  },

  components: { DataTable, LoadingComponent},
  data() {
    return {
      loading: false

    };
  },
  computed: {
    titles() {
      return {
        id: "#",
        name: this.$t("locationsPage.name"),
        polygon: this.$t("locationsPage.polygon"),
        from: this.$t("locationsPage.from"),
        to: this.$t("locationsPage.to"),
        created_at: this.$t("locationsPage.dateCreated"),
        updated_at: this.$t("locationsPage.dateUpdated"),
      };
    },

    actionsExtraMain() {
      return {
        duplicate: {
          title: this.$t("locationsPage.actionDuplicate"),
          icon: "content_copy",
          action: (item) =>
            this.duplicateItem(item)
        },
        edit: {
          action: (item) =>
            this.$router.push({
              name: "RestrictedAreasEditor",
              params: { id: item.id },
            }),
        },
        add: {
          action: () =>
            this.$router.push({
              name: "RestrictedAreasAdder",
            }),
        },

      };
    },
    formatter() {
      return {
        polygon(polygon) {
          let smallest = Array(2).fill(Math.pow(2, 32));
          let biggest = Array(2).fill(-Math.pow(2, 32));
          for (let arr of polygon.coordinates[0]) {
            smallest[0] = Math.min(smallest[0], arr[0]);
            smallest[1] = Math.min(smallest[1], arr[1]);
            biggest[0] = Math.max(biggest[0], arr[0]);
            biggest[1] = Math.max(biggest[1], arr[1]);
          }
          return `
            <svg height="75" width="75" viewBox="-75 0 75 75">
              <polygon points="${polygon.coordinates[0]
              .map(
                (arr) =>
                  (-(biggest[0] - arr[0]) / (biggest[0] - smallest[0])) * 75 +
                  "," +
                  ((biggest[1] - arr[1]) / (biggest[1] - smallest[1])) * 75
              )
              .join(" ")}" style="fill:lime;stroke:purple;stroke-width:1;"/>
            </svg>
          `;
        },
        created_at(value) { return formatCompanyTime(value, "DD-MM-YYYY  HH:mm"); },
        updated_at(value) { return formatCompanyTime(value, "DD-MM-YYYY  HH:mm"); },
        from(value) { return formatCompanyTime(value, "DD-MM-YYYY  HH:mm"); },
        to(value) { return formatCompanyTime(value, "DD-MM-YYYY  HH:mm"); }

      };
    },
  },
  methods: {
    duplicateItem(item) {
      confirm(this.$t("locationsPage.confirmDuplicate")) &&
        (() => {
          this.loading = true;
          axios
            .post("restricted-area-duplicate",{id: item.id})
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.toastDuplicated"), "green");
              this.$refs.dataTable.getData();
            })
            .catch(({ response }) => {
              if (response && response.data && response.data.message)
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("locationsPage.errorHappened"),
                  "red"
                );
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })();
    }
  }
};
</script>

<style scoped></style>
